import CloseIcon from '@ixigo/icons/Close';
import Button from '@ixigo/iui/Button';
import Typography from '@ixigo/iui/Typography';
import { Fragment } from 'react/jsx-runtime';
import { NavigationHeader } from '@/components';
import { WarningExclaimation, WarningTick } from '@/routes/_auth/-icons';

interface CancellationFailureProps {
	onClose: () => void;
	onGetHelp: () => void;
	onTryAgain: () => void;
}

export const CancellationFailure = ({
	onClose,
	onGetHelp,
	onTryAgain,
}: CancellationFailureProps) => {
	return (
		<Fragment>
			<NavigationHeader
				title=""
				leftAction={onClose}
				leftIcon={<CloseIcon />}
			/>
			<div className="bg-primary px-20 pb-30 flex flex-col gap-y-10">
				<div className="flex items-center justify-center">
					<WarningExclaimation className="size-50px" />
				</div>
				<div className="flex flex-col gap-y-10 text-center">
					<Typography variant="h5" fontWeight="medium">
						Oops! Cancellation Failed
					</Typography>
					<Typography variant="body-md">
						Sorry, we could not cancel your ride due to some technical issue.
					</Typography>
				</div>
			</div>
			<div className="bg-primary px-20 py-2.5 flex justify-between items-center gap-x-20">
				<Button onClick={onGetHelp} className="w-full" size="lg" variant="soft">
					Get Help
				</Button>
				<Button
					onClick={onTryAgain}
					className="w-full"
					size="lg"
					variant="solid"
				>
					Try Again
				</Button>
			</div>
		</Fragment>
	);
};

export const CancellationSuccess = ({ onClose }: { onClose: () => void }) => {
	return (
		<div className="p-20 pt-10">
			<CloseIcon onClick={onClose} />
			<div className="flex flex-col gap-y-30">
				<div className="flex items-center justify-center">
					<WarningTick className="size-100px" />
				</div>
				<div className="flex flex-col gap-y-10 text-center">
					<Typography variant="body-lg" fontWeight="medium">
						Ride cancelled successfully
					</Typography>
					<Typography variant="body-md" className="text-secondary">
						You will receive a cancellation confirmation communication shortly
					</Typography>
				</div>
			</div>
		</div>
	);
};
